var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Tab, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useHorizontalSubMenuContext } from './HorizontalSubMenuContext';
import { useAppLocationMatcher, useAppLocationState } from '../app-location';
import { useHorizontalMenuContext } from './HorizontalMenuContext';
import { SubMenu } from './SubMenu';
import { SubMenuItem } from './SubMenuItem';
import { useTranslate } from 'react-admin';
export var HorizontalMenuItem = function (_a) {
    var label = _a.label, to = _a.to, _b = _a.value, value = _b === void 0 ? '' : _b, children = _a.children, TabProps = _a.TabProps, MenuItemProps = _a.MenuItemProps, MenuProps = _a.MenuProps, className = _a.className, props = __rest(_a, ["label", "to", "value", "children", "TabProps", "MenuItemProps", "MenuProps", "className"]);
    var _c = useAppLocationState(), setLocation = _c[1];
    var match = useAppLocationMatcher();
    var horizontalSubMenuContext = useHorizontalSubMenuContext();
    var horizontalMenuContext = useHorizontalMenuContext();
    var translate = useTranslate();
    var translatedLabel = label ? translate(label, { _: label }) : value;
    useEffect(function () { return horizontalMenuContext.addPath(value); }, [horizontalMenuContext, value]);
    if (horizontalSubMenuContext) {
        return (_jsx(SubMenuItem, __assign({ value: value, label: translatedLabel, to: to || "/".concat(value) }, MenuItemProps, props)));
    }
    if (!children) {
        return (_jsx(Root, { children: _jsx(StyledTab, __assign({ className: clsx(className, match(value) ? HorizontalMenuItemClasses.selected : ''), value: value, label: translatedLabel, to: to || "/".concat(value), component: Link, onClick: function () { return setLocation(value); } }, TabProps, props)) }));
    }
    return (_jsx(SubMenu, __assign({ value: value, label: translatedLabel, TabProps: TabProps, MenuProps: MenuProps }, props, { children: children })));
};
var PREFIX = 'RaHorizontalMenuItem';
var HorizontalMenuItemClasses = {
    selected: "".concat(PREFIX, "-selected"),
};
var Root = styled('div')((_a = {},
    _a["& .".concat(HorizontalMenuItemClasses.selected)] = {
        fontWeight: 600,
    },
    _a));
var StyledTab = styled(Tab)({
    opacity: 1,
});
